import { render } from "./Formato2008.vue?vue&type=template&id=67747e0d&scoped=true"
import script from "./Formato2008.vue?vue&type=script&lang=js"
export * from "./Formato2008.vue?vue&type=script&lang=js"

import "./Formato2008.vue?vue&type=style&index=0&id=67747e0d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67747e0d"]])

export default __exports__